import React from 'react';
import { products } from '../../data/products';
import { priceRanges } from '../../data/shopFilters';
import { getCurrentCreators, isProductLeavingSoon } from '../../utils/catalog';
import type { ShopFiltersState } from '../../hooks/useShopFilters';
function FilterGroup({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <fieldset className="border-b border-line py-5 first:pt-0" data-id="element-582" data-mp="3viiut4m5rx85">
      <legend className="mb-3 text-sm font-medium" data-id="element-583" data-mp="3qid69xb6qqua">{title}</legend>
      <div className="space-y-2.5" data-id="element-584" data-mp="3lqv79esq30by">{children}</div>
    </fieldset>;
}
function CheckRow({
  checked,
  onChange,
  label,
  count,
  type = 'checkbox',
  name
}: {
  checked: boolean;
  onChange: () => void;
  label: string;
  count?: number;
  type?: 'checkbox' | 'radio';
  name?: string;
}) {
  return <label className="flex cursor-pointer items-center gap-3 text-sm" data-id="element-585" data-mp="37rdhaw3oxh10">
      <input type={type} name={name} checked={checked} onChange={onChange} className="h-4 w-4 accent-clay" data-id="element-586" data-mp="32rr0kconling" />
      <span className="flex-1" data-id="element-587" data-mp="3gryjzn2bhp4t">{label}</span>
      {count !== undefined && <span className="text-xs text-muted tabular-nums" data-id="element-588" data-mp="3gplqqdr3zscg">{count}</span>}
    </label>;
}
export function ShopFilters({
  filters
}: {
  filters: ShopFiltersState;
}) {
  const creatorsWithProducts = getCurrentCreators().filter(c => products.some(p => p.creatorId === c.id));
  const leavingCount = products.filter(isProductLeavingSoon).length;
  const uniqueCount = products.filter(p => p.stock === 1).length;
  return <div data-id="element-589" data-mp="8bwlx30x4k68">
      <FilterGroup title="Disponibilité" data-id="element-590" data-mp="8bn0lsqtj16v">
        <CheckRow checked={filters.leavingOnly} onChange={filters.toggleLeaving} label="Derniers jours en vitrine" count={leavingCount} data-id="element-591" data-mp="8bd5xrutw5uu" />
        <CheckRow checked={filters.uniqueOnly} onChange={filters.toggleUnique} label="Pièces uniques" count={uniqueCount} data-id="element-592" data-mp="3vgmbni91leph" />
      </FilterGroup>
      <FilterGroup title="Prix" data-id="element-593" data-mp="2f1b7y7gr4hb4">
        {priceRanges.map(r => <CheckRow key={r.value} type="radio" name="prix" checked={filters.price === r.value} onChange={() => filters.setPrice(r.value)} label={r.label} data-id="element-594" data-mp="2k163wpfdvx31" />)}
      </FilterGroup>
      <FilterGroup title="Créateurs en vitrine" data-id="element-595" data-mp="1vzuapreme2dd">
        {creatorsWithProducts.map(c => <CheckRow key={c.id} checked={filters.creatorIds.includes(c.id)} onChange={() => filters.toggleCreator(c.id)} label={c.name} count={products.filter(p => p.creatorId === c.id).length} data-id="element-596" data-mp="1r4wspuzd4ioc" />)}
      </FilterGroup>
      {filters.activeFilters.length > 0 && <button type="button" onClick={filters.resetFilters} className="mt-5 text-sm underline underline-offset-4 hover:text-clay" data-id="element-597" data-mp="187n9oexy977m">
          Effacer les filtres
        </button>}
    </div>;
}